import axios from "axios";
import Swal from "sweetalert2";
import { tokenConfig } from "./websiteActions";
import { t } from "i18next";
import { sleep } from "components/Function";

const getListOrders =
    (
        page = 0,
        sizeperpage = 0,
        search = "",
        filter = "",
        filter2 = "",
        filter3 = "",
        filter4 = "",
        filter5 = "",
        filter6 = "",
        filter7 = "",
        filter8 = "",
        filter9 = "",
        filter10 = "",
    ) =>
        (dispatch, getState) => {
            dispatch({ type: "LOADING_ORDER", payload: true });
            var param_search = "";
            if (search !== "") {
                param_search = `&search=${search?.trim()?.split("\n")?.join(",")}`;
            }
            var param_filter = "";
            if (filter.length > 0) {
                param_filter = `&filter=${filter}`;
            }
            var param_filter2 = "";
            if (filter2.length > 0) {
                param_filter2 = `&filter2=${filter2}`;
            }
            var param_filter3 = "";
            if (filter3.length > 0) {
                param_filter3 = `&filter3=${filter3}`;
            }
            var param_filter4 = "";
            if (filter4.length > 0) {
                param_filter4 = `&filter4=${filter4}`;
            }
            var param_filter5 = "";
            if (filter5.length > 0) {
                param_filter5 = `&filter5=${filter5}`;
            }
            var param_filter6 = "";
            if (filter6.length > 0) {
                param_filter6 = `&filter6=${filter6}`;
            }
            var param_filter7 = "";
            if (filter7 !== "") {
                param_filter7 = `&filter7=${filter7}`;
            }
            var param_filter8 = "";
            if (filter8 !== "") {
                param_filter8 = `&filter8=${filter8}`;
            }
            var param_filter9 = "";
            if (filter9 !== "") {
                param_filter9 = `&filter9=${filter9}`;
            }
            var param_filter10 = "";
            if (filter10 !== "") {
                param_filter10 = `&filter10=${filter10}`;
            }
            return axios
                .get(
                    `/api/order/list?page=${page}&sizeperpage=${sizeperpage}${param_search}${param_filter}${param_filter2}${param_filter3}${param_filter4}${param_filter5}${param_filter6}${param_filter7}${param_filter8}${param_filter9}${param_filter10}`,
                    tokenConfig(getState)
                )
                .then((res) => {
                    dispatch({ type: "LOADING_ORDER", payload: false });
                    if (res.data.status === 200) {
                        dispatch({
                            type: "LIST_ORDER",
                            payload: res.data.data,
                        });
                        return res.data.data;
                    } else {
                        Swal.fire(t("Error"), t(res.data.message), "error");
                    }
                })
                .catch((err) => {
                    dispatch({ type: "LOADING_ORDER", payload: false });
                    Swal.fire(t("Error"), t("An error occurred!"), "error");
                });
        };

const getListOrdersAdmin =
    ({ page = 0, sizePerPage = 0, filter }) =>
        (dispatch, getState) => {
            const filterQuery = new URLSearchParams(filter).toString();
            return axios
                .get(`/api/order/admin?page=${page}&sizeperpage=${sizePerPage}&${filterQuery}`, tokenConfig(getState))
                .then((res) => {
                    if (res.data.status === 200) {
                        return res.data.data;
                    } else {
                        Swal.fire(t("Error"), t(res.data.message), "error");
                    }
                })
                .catch((err) => {
                    Swal.fire(t("Error"), t("An error occurred!"), "error");
                });
        };

const saveEditOrder =
    (data, closemodal = () => { }) =>
        (dispatch, getState) => {
            var body = {
                _id: data?._id,
                keywords: data?.keywords,
                type: data?.type,
                printer: data?.printer,
                design_fee: data?.design_fee,
                folder_google_drive_url: data?.folder_google_drive_url,
                mockup: data?.mockup,
                design: data?.design,
                line_print: data?.line_print,
                shipping_label: data?.shipping_label,
                scan_label: data?.scan_label,
                order_status: data?.order_status,
                tracking_number: data?.tracking_number,
                fulfillment_order_id: data?.fulfillment_order_id,
                base_cost: data?.base_cost,
                staff_note: data?.staff_note,
                data_viettelpost: data?.data_viettelpost,
            };
            // Swal.fire({
            // 	title: t("Are you sure?"),
            // 	text: t("Are you sure to edit order?"),
            // 	icon: 'warning',
            // 	showCancelButton: true,
            // 	confirmButtonColor: '#3085d6',
            // 	cancelButtonColor: '#d33',
            // 	confirmButtonText: t("Sure"),
            // 	cancelButtonText: t("Cancel")
            // }).then((result) => {
            // 	if (result.value) {
            dispatch({ type: "LOADING_ORDER", payload: true });
            if (data?.tracking_number && data?.tracking_number !== "") {
                axios
                    .post("/api/order/tracking-number", body, tokenConfig(getState))
                    .then((res) => {
                        dispatch({ type: "LOADING_ORDER", payload: false });
                        if (res.data.status === 200) {
                            closemodal();
                            dispatch(
                                getListOrders(
                                    data.page,
                                    data.sizePerPage,
                                    data.searchText,
                                    data.filter_printer,
                                    data.filter_shop_code,
                                    data.filter_status,
                                    data.filter_work_status,
                                    data.filter_staff_note,
                                    data.filter_staff,
                                    data.filter_order_design,
                                    data.filter_shipping_type,
                                    data.dateStart,
                                    data.dateEnd
                                )
                            );
                            // Swal.fire(t("Success"), t(res.data.message), 'success');
                        } else {
                            Swal.fire(t("Error"), t(res.data.message), "error");
                        }
                    })
                    .catch((err) => {
                        dispatch({ type: "LOADING_ORDER", payload: false });
                        Swal.fire(t("Error"), t("An error occurred!"), "error");
                    });
            } else {
                axios
                    .post("/api/order/edit", body, tokenConfig(getState))
                    .then((res) => {
                        dispatch({ type: "LOADING_ORDER", payload: false });
                        if (res.data.status === 200) {
                            closemodal();
                            dispatch(
                                getListOrders(
                                    data.page,
                                    data.sizePerPage,
                                    data.searchText,
                                    data.filter_printer,
                                    data.filter_shop_code,
                                    data.filter_status,
                                    data.filter_work_status,
                                    data.filter_staff_note,
                                    data.filter_staff,
                                    data.filter_order_design,
                                    data.filter_shipping_type,
                                    data.dateStart,
                                    data.dateEnd
                                )
                            );
                            // Swal.fire(t("Success"), t(res.data.message), 'success');
                        } else {
                            Swal.fire(t("Error"), t(res.data.message), "error");
                        }
                    })
                    .catch((err) => {
                        dispatch({ type: "LOADING_ORDER", payload: false });
                        Swal.fire(t("Error"), t("An error occurred!"), "error");
                    });
            }

            // 	}
            // })
        };

const saveEditOrderMember =
    (data, closemodal = () => { }) =>
        (dispatch, getState) => {
            Swal.fire({
                title: t("Are you sure?"),
                text: t("Are you sure to edit member order?"),
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: t("Sure"),
                cancelButtonText: t("Cancel"),
            }).then((result) => {
                if (result.value) {
                    dispatch({ type: "LOADING_ORDER", payload: true });
                    axios
                        .post("/api/order/edit-member", data, tokenConfig(getState))
                        .then((res) => {
                            dispatch({ type: "LOADING_ORDER", payload: false });
                            if (res.data.status === 200) {
                                closemodal();
                                dispatch(
                                    getListOrders(
                                        data.page,
                                        data.sizePerPage,
                                        data.searchText,
                                        data.filter_printer,
                                        data.filter_shop_code,
                                        data.filter_status,
                                        data.filter_work_status,
                                        data.filter_staff_note,
                                        data.filter_staff,
                                        data.filter_order_design,
                                        data.filter_shipping_type,
                                        data.dateStart,
                                        data.dateEnd
                                    )
                                );
                                Swal.fire(t("Success"), t(res.data.message), "success");
                            } else {
                                Swal.fire(t("Error"), t(res.data.message), "error");
                            }
                        })
                        .catch((err) => {
                            dispatch({ type: "LOADING_ORDER", payload: false });
                            Swal.fire(t("Error"), t("An error occurred!"), "error");
                        });
                }
            });
        };

const sendToPrinter = (data) => (dispatch, getState) => {
    var body = {
        _id: data?._id ? data?._id.split(",") : [],
    };
    Swal.fire({
        title: t("Are you sure?"),
        text: t("Are you sure to send to printer?"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: t("Sure"),
        cancelButtonText: t("Cancel"),
    }).then((result) => {
        if (result.value) {
            dispatch({ type: "LOADING_ORDER", payload: true });
            axios
                .post("/api/order/send-to-printer", body, tokenConfig(getState))
                .then((res) => {
                    dispatch({ type: "LOADING_ORDER", payload: false });
                    if (res.data.status === 200) {
                        data.setOrdersSelected([]);
                        dispatch(
                            getListOrders(
                                data.page,
                                data.sizePerPage,
                                data.searchText,
                                data.filter_printer,
                                data.filter_shop_code,
                                data.filter_status,
                                data.filter_work_status,
                                data.filter_staff_note,
                                data.filter_staff,
                                data.filter_order_design,
                                data.filter_shipping_type,
                                data.dateStart,
                                data.dateEnd
                            )
                        );
                        Swal.fire(t("Logs"), t(res.data.message), "warning");
                    } else {
                        Swal.fire(t("Error"), t(res.data.message), "error");
                    }
                })
                .catch((err) => {
                    dispatch({ type: "LOADING_ORDER", payload: false });
                    data.setOrdersSelected([]);
                    dispatch(
                        getListOrders(
                            data.page,
                            data.sizePerPage,
                            data.searchText,
                            data.filter_printer,
                            data.filter_shop_code,
                            data.filter_status,
                            data.filter_work_status,
                            data.filter_staff_note,
                            data.filter_staff,
                            data.filter_order_design,
                            data.filter_shipping_type,
                            data.dateStart,
                            data.dateEnd
                        )
                    );
                    // Swal.fire(t("Error"), t("An error occurred!"), 'error');
                });
        }
    });
};

const syncOrderStatement = (id) => (dispatch, getState) => {
    return axios.post("/api/order/sync-orders-statement", { orderId: id }, tokenConfig(getState));
};

const cancelToPrinter = (data) => (dispatch, getState) => {
    var body = {
        _id: data?._id ? data?._id.split(",") : [],
    };
    Swal.fire({
        title: t("Are you sure?"),
        text: t("Are you sure to cancel to printer?"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: t("Sure"),
        cancelButtonText: t("Cancel"),
    }).then((result) => {
        if (result.value) {
            dispatch({ type: "LOADING_ORDER", payload: true });
            axios
                .post("/api/order/cancel-to-printer", body, tokenConfig(getState))
                .then((res) => {
                    dispatch({ type: "LOADING_ORDER", payload: false });
                    if (res.data.status === 200) {
                        dispatch(
                            getListOrders(
                                data.page,
                                data.sizePerPage,
                                data.searchText,
                                data.filter_printer,
                                data.filter_shop_code,
                                data.filter_status,
                                data.filter_work_status,
                                data.filter_staff_note,
                                data.filter_staff,
                                data.filter_order_design,
                                data.filter_shipping_type,
                                data.dateStart,
                                data.dateEnd
                            )
                        );
                        Swal.fire(t("Success"), t(res.data.message), "success");
                    } else {
                        Swal.fire(t("Error"), t(res.data.message), "error");
                    }
                })
                .catch((err) => {
                    dispatch({ type: "LOADING_ORDER", payload: false });
                    Swal.fire(t("Error"), t("An error occurred!"), "error");
                });
        }
    });
};

const cancelOrderTiktok = (data) => (dispatch, getState) => {
    var body = {
        orderId: data.orderId,
        cancel_reason: data.cancel_reason,
    };
    return Swal.fire({
        title: t("Are you sure?"),
        text: t("Are you sure to cancel order?"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: t("Sure"),
        cancelButtonText: t("Cancel"),
    }).then((result) => {
        if (result.value) {
            dispatch({ type: "LOADING_ORDER", payload: true });
            return axios
                .post("/api/order/cancel-tiktok", body, tokenConfig(getState))
                .then((res) => {
                    dispatch({ type: "LOADING_ORDER", payload: false });
                    if (res.data.status === 200) {
                        Swal.fire(t("Success"), t(res.data.message), "success");
                    } else {
                        Swal.fire(t("Error"), t(res.data.message), "error");
                    }
                })
                .catch((err) => {
                    dispatch({ type: "LOADING_ORDER", payload: false });
                    Swal.fire(t("Error"), t("An error occurred!"), "error");
                });
        }
    });
};

const exportOrder =
    (search = "", filter = "", filter2 = "", filter3 = "", filter4 = "", filter5 = "", filter6 = "", filter7 = "", filter8 = "", filter9 = "", filter10 = "", filter13 = "") =>
        async (dispatch, getState) => {
            dispatch({ type: "LOADING_ORDER", payload: true });

            let page = 1;
            const sizeperpage = 250;
            let allData = [];
            let hasMore = true;

            // var param_search = "";
            // if (search !== "") {
            //     param_search = `&search=${search?.trim()?.split("\n")?.join(",")}`;
            // }
            var param_filter = "";
            if (filter.length > 0) {
                param_filter = `&filter=${filter}`;
            }
            var param_filter2 = "";
            if (filter2.length > 0) {
                param_filter2 = `&filter2=${filter2}`;
            }
            var param_filter3 = "";
            if (filter3.length > 0) {
                param_filter3 = `&filter3=${filter3}`;
            }
            var param_filter4 = "";
            if (filter4.length > 0) {
                param_filter4 = `&filter4=${filter4}`;
            }
            var param_filter5 = "";
            if (filter5.length > 0) {
                param_filter5 = `&filter5=${filter5}`;
            }
            var param_filter6 = "";
            if (filter6.length > 0) {
                param_filter6 = `&filter6=${filter6}`;
            }
            var param_filter7 = "";
            if (filter7 !== "") {
                param_filter7 = `&filter7=${filter7}`;
            }
            var param_filter8 = "";
            if (filter8 !== "") {
                param_filter8 = `&filter8=${filter8}`;
            }
            var param_filter9 = "";
            if (filter9 !== "") {
                param_filter9 = `&filter9=${filter9}`;
            }
            var param_filter10 = "";
            if (filter10 !== "") {
                param_filter10 = `&filter10=${filter10}`;
            }
            var param_filter13 = "";
            if (filter13 !== "") {
                param_filter13 = `&filter13=${filter13}`;
            }
            try {
                while (hasMore) {
                    const res = await axios
                        .post(
                            `/api/order/export?page=${page}&sizeperpage=${sizeperpage}${param_filter}${param_filter2}${param_filter3}${param_filter4}${param_filter5}${param_filter6}${param_filter7}${param_filter8}${param_filter9}${param_filter10}${param_filter13}`, { search },
                            tokenConfig(getState)
                        );
                    if (res.data.status !== 200) {
                        throw new Error(res.data.message);
                    }

                    const data = res.data.data.all_orders_for_export;
                    allData = [...allData, ...data];

                    if (data.length < sizeperpage) {
                        hasMore = false;
                    } else {
                        page++;
                    }
                }

                dispatch({
                    type: "EXPORT_ORDER",
                    payload: { all_orders_for_export: allData },
                });
            } catch (err) {
                // console.log(err);
                Swal.fire("Error", "Export failed!", "error");
            } finally {
                dispatch({ type: "LOADING_ORDER", payload: false });
            }
        };

const importTracking = (data, closemodal, setIsOpenModalImportTrackingV2, setImportTrackingV2, delay_time) => (dispatch, getState) => {
    Swal.fire({
        title: "Are you sure?",
        text: "Are you sure to import tracking?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Sure",
        cancelButtonText: "Cancel",
    }).then((result) => {
        if (result.value) {
            dispatch({ type: "LOADING_ORDER", payload: true });
            var options = {
                method: "POST",
                url: "/api/order/import-tracking",
                headers: {
                    "Content-Type": "multipart/form-data;",
                    "al-token": getState().user.token,
                },
                data: data.formData,
            };
            axios
                .request(options)
                .then(async function (res) {
                    if (res.data.status === 200) {
                        var tracking_error_apiOrderId = res.data.data.tracking_error.apiOrderId.length > 0 ? res.data.data.tracking_error.apiOrderId.split(",") : [];
                        var tracking_error_tracking_number = res.data.data.tracking_error.tracking_number.length > 0 ? res.data.data.tracking_error.tracking_number.split(",") : [];
                        var message_error = res.data.data.message_error.length > 0 ? res.data.data.message_error.split(",") : [];
                        const promise_import_tracking = Object.entries(res.data.data.final_data).map(async ([key, items]) => {
                            for (const item of items) {
                                var body = {
                                    ...item
                                };
                                await axios
                                    .post("/api/order/import-tracking-parallel", body, tokenConfig(getState))
                                    .then((res) => {
                                        if (res.data.status === 200) {
                                            if (res.data.data?.tracking_error) {
                                                tracking_error_apiOrderId.push(res.data.data?.tracking_error?.apiOrderId);
                                                tracking_error_tracking_number.push(res.data.data?.tracking_error?.tracking_number);
                                            }
                                            if (res.data.data?.message_error) {
                                                message_error.push(res.data.data?.message_error);
                                            }
                                        }
                                    })
                                    .catch((err) => {
                                        // Swal.fire(t("Error"), t("An error occurred!"), "error");
                                    });

                                await sleep(delay_time*1000);
                            }
                            return true;
                        });
                        await Promise.all(promise_import_tracking);

                        dispatch({ type: "LOADING_ORDER", payload: false });
                        closemodal();
                        if (tracking_error_apiOrderId.length > 0) {
                            setIsOpenModalImportTrackingV2(true);
                            setImportTrackingV2({ apiOrderId: tracking_error_apiOrderId.join(), tracking_number: tracking_error_tracking_number.join(), message: message_error.join(), page: 1, sizePerPage: 10 });
                        } else {
                            Swal.fire(t("Success"), t(res.data.message), "success");
                        }
                    } else {
                        dispatch({ type: "LOADING_ORDER", payload: false });
                        Swal.fire(t("Error"), t(res.data.message), "error");
                    }
                })
                .catch((err) => {
                    dispatch({ type: "LOADING_ORDER", payload: false });
                    Swal.fire("Error", "An error occurred!", "error");
                });
        }
    });
};

const getListSyncOrderStatement = () => (dispatch, getState) => {
    dispatch({ type: "LOADING_ORDER", payload: true });
    return axios
        .get(`/api/order/list-sync-statement`, tokenConfig(getState))
        .then((res) => {
            dispatch({ type: "LOADING_ORDER", payload: false });
            if (res.data.status === 200) {
                return res.data.data;
            } else {
                Swal.fire(t("Error"), t(res.data.message), "error");
            }
        })
        .catch((err) => {
            dispatch({ type: "LOADING_ORDER", payload: false });
            Swal.fire(t("Error"), t("An error occurred!"), "error");
        });
};

const saveImportTrackingV2 =
    (data, closemodal = () => { }) =>
        (dispatch, getState) => {
            var body = {
                list: data?.list,
            };
            Swal.fire({
                title: t("Are you sure?"),
                text: t("Are you sure to import tracking?"),
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: t("Sure"),
                cancelButtonText: t("Cancel"),
            }).then((result) => {
                if (result.value) {
                    dispatch({ type: "LOADING_ORDER", payload: true });
                    axios
                        .post("/api/order/import-tracking-v2", body, tokenConfig(getState))
                        .then((res) => {
                            dispatch({ type: "LOADING_ORDER", payload: false });
                            if (res.data.status === 200) {
                                closemodal();
                                dispatch(
                                    getListOrders(
                                        data.page,
                                        data.sizePerPage,
                                        data.searchText,
                                        data.filter_printer,
                                        data.filter_shop_code,
                                        data.filter_status,
                                        data.filter_work_status,
                                        data.filter_staff_note,
                                        data.filter_staff,
                                        data.filter_order_design,
                                        data.filter_shipping_type,
                                        data.dateStart,
                                        data.dateEnd
                                    )
                                );
                                if (res?.data?.data?.logUpdate?.length > 0) {
                                    Swal.fire({
                                        title: t("Data error!"),
                                        html: `<div style="text-align: left; max-height: 400px; overflow-y: auto;">${res?.data?.data?.logUpdate?.map((l) => l.apiOrderId + ": " + l.status).join("<br/>")}</div>`,
                                        icon: "warning",
                                    });
                                } else {

                                    Swal.fire(t("Success"), t(res.data.message), "success");
                                }
                            } else {
                                Swal.fire(t("Error"), t(res.data.message), "error");
                            }
                        })
                        .catch((err) => {
                            dispatch({ type: "LOADING_ORDER", payload: false });
                            Swal.fire(t("Error"), t("An error occurred!"), "error");
                        });
                }
            });
        };

const syncMatchDesign = (data) => (dispatch, getState) => {
    var body = {};
    return Swal.fire({
        title: t("Are you sure?"),
        text: t("Are you sure to sync match design?"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: t("Sure"),
        cancelButtonText: t("Cancel"),
    }).then((result) => {
        if (result.value) {
            dispatch({ type: "LOADING_ORDER", payload: true });
            return axios
                .post("/api/order/sync-match-design", body, tokenConfig(getState))
                .then((res) => {
                    dispatch({ type: "LOADING_ORDER", payload: false });
                    if (res.data.status === 200) {
                        dispatch(
                            getListOrders(
                                data.page,
                                data.sizePerPage,
                                data.searchText,
                                data.filter_printer,
                                data.filter_shop_code,
                                data.filter_status,
                                data.filter_work_status,
                                data.filter_staff_note,
                                data.filter_staff,
                                data.filter_order_design,
                                data.filter_shipping_type,
                                data.dateStart,
                                data.dateEnd
                            )
                        );
                        Swal.fire(t("Success"), t(res.data.message), "success");
                    } else {
                        Swal.fire(t("Error"), t(res.data.message), "error");
                    }
                })
                .catch((err) => {
                    dispatch({ type: "LOADING_ORDER", payload: false });
                    Swal.fire(t("Error"), t("An error occurred!"), "error");
                });
        }
    });
};

const getMatchDesign = (data) => (dispatch, getState) => {
    var body = {
        _id: data?._id
    };
    return Swal.fire({
        title: t("Are you sure?"),
        text: t("Are you sure to get match design?"),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: t("Sure"),
        cancelButtonText: t("Cancel")
    }).then((result) => {
        if (result.value) {
            dispatch({ type: 'LOADING_ORDER', payload: true });
            return axios.post('/api/order/get-match-design', body, tokenConfig(getState)).then(res => {
                dispatch({ type: 'LOADING_ORDER', payload: false });
                if (res.data.status === 200) {
                    data?.setMockup(res.data.data.mockup);
                    data?.setDesign(res.data.data.design);
                    data?.setPrinter(res.data.data.printer);
                    Swal.fire(t("Success"), t(res.data.message), 'success');
                } else {
                    Swal.fire(t("Error"), t(res.data.message), 'error');
                }
            }).catch(err => {
                dispatch({ type: 'LOADING_ORDER', payload: false });
                Swal.fire(t("Error"), t("An error occurred!"), 'error');
            });
        }
    })
};

const combinePackage = (data) => (dispatch, getState) => {
    var body = {
        _id: data?._id ? data?._id.split(",") : [],
    };
    return Swal.fire({
        title: t("Are you sure?"),
        text: t("Are you sure to combine package?"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: t("Sure"),
        cancelButtonText: t("Cancel"),
    }).then((result) => {
        if (result.value) {
            dispatch({ type: "LOADING_ORDER", payload: true });
            return axios
                .post("/api/order/combine-package", body, tokenConfig(getState))
                .then((res) => {
                    dispatch({ type: "LOADING_ORDER", payload: false });
                    if (res.data.status === 200) {
                        data.setOrdersSelected([]);
                        dispatch(
                            getListOrders(
                                data.page,
                                data.sizePerPage,
                                data.searchText,
                                data.filter_printer,
                                data.filter_shop_code,
                                data.filter_status,
                                data.filter_work_status,
                                data.filter_staff_note,
                                data.filter_staff,
                                data.filter_order_design,
                                data.filter_shipping_type,
                                data.dateStart,
                                data.dateEnd
                            )
                        );
                        Swal.fire(t("Logs"), t(res.data.message), "warning");
                    } else {
                        Swal.fire(t("Error"), t(res.data.message), "error");
                    }
                })
                .catch((err) => {
                    dispatch({ type: "LOADING_ORDER", payload: false });
                    Swal.fire(t("Error"), t("An error occurred!"), "error");
                });
        }
    });
};

const makeOrderComplete = (data) => (dispatch, getState) => {
    var body = {
        _id: data?._id ? data?._id.split(",") : [],
    };
    return Swal.fire({
        title: t("Are you sure?"),
        text: t("Are you sure to make order complete?"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: t("Sure"),
        cancelButtonText: t("Cancel"),
    }).then((result) => {
        if (result.value) {
            dispatch({ type: "LOADING_ORDER", payload: true });
            return axios
                .post("/api/order/make-order-complete", body, tokenConfig(getState))
                .then((res) => {
                    dispatch({ type: "LOADING_ORDER", payload: false });
                    if (res.data.status === 200) {
                        data.setOrdersSelected([]);
                        dispatch(
                            getListOrders(
                                data.page,
                                data.sizePerPage,
                                data.searchText,
                                data.filter_printer,
                                data.filter_shop_code,
                                data.filter_status,
                                data.filter_work_status,
                                data.filter_staff_note,
                                data.filter_staff,
                                data.filter_order_design,
                                data.filter_shipping_type,
                                data.dateStart,
                                data.dateEnd
                            )
                        );
                        Swal.fire(t("Logs"), t(res.data.message), "warning");
                    } else {
                        Swal.fire(t("Error"), t(res.data.message), "error");
                    }
                })
                .catch((err) => {
                    dispatch({ type: "LOADING_ORDER", payload: false });
                    Swal.fire(t("Error"), t("An error occurred!"), "error");
                });
        }
    });
};

const uploadInvoice = (data, closemodal) => (dispatch, getState) => {
    Swal.fire({
        title: "Are you sure?",
        text: "Are you sure to upload invoice?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Sure",
        cancelButtonText: "Cancel",
    }).then((result) => {
        if (result.value) {
            dispatch({ type: "LOADING_ORDER", payload: true });
            var options = {
                method: "POST",
                url: "/api/order/upload-invoice",
                headers: {
                    "Content-Type": "multipart/form-data;",
                    "al-token": getState().user.token,
                },
                data: data.formData,
            };
            axios
                .request(options)
                .then(function (res) {
                    dispatch({ type: "LOADING_ORDER", payload: false });
                    if (res.data.status === 200) {
                        closemodal();
                        dispatch(
                            getListOrders(
                                data.page,
                                data.sizePerPage,
                                data.searchText,
                                data.filter_printer,
                                data.filter_shop_code,
                                data.filter_status,
                                data.filter_work_status,
                                data.filter_staff_note,
                                data.filter_staff,
                                data.filter_order_design,
                                data.filter_shipping_type,
                                data.dateStart,
                                data.dateEnd
                            )
                        );
                        Swal.fire(t("Success"), t(res.data.message), "success");
                    } else {
                        Swal.fire(t("Error"), t(res.data.message), "error");
                    }
                })
                .catch((err) => {
                    dispatch({ type: "LOADING_ORDER", payload: false });
                    Swal.fire("Error", "An error occurred!", "error");
                });
        }
    });
};

export {
    getListOrders,
    saveEditOrder,
    sendToPrinter,
    cancelToPrinter,
    saveEditOrderMember,
    exportOrder,
    importTracking,
    cancelOrderTiktok,
    syncOrderStatement,
    getListSyncOrderStatement,
    saveImportTrackingV2,
    syncMatchDesign,
    getMatchDesign,
    getListOrdersAdmin,
    combinePackage,
    makeOrderComplete,
    uploadInvoice
};
